<template>
  <div>
    <footer>
      <p>版权所有2019&nbsp;&nbsp;&nbsp;鄂ICP备14010630号</p>
      <a href="http://www.rayplus.com" target="view_window">技术支持：睿佳科技 www.rayplus.com</a>
    </footer>
  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  components: {},
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {}
};
</script>
<style lang="scss" scoped>
@import "./Footer.scss";
</style>
